export const AVAILABLE_COUNTRIES = {
    "Austria": "AT",
    "Belgium": "BE",
    "Bulgaria": "BG",
    "Croatia": "HR",
    "Cyprus": "CY",
    "Czech Republic": "CZ",
    "Canary Islands": "IC",
    "Denmark": "DK",
    "Estonia": "EE",
    "Finland": "FI",
    "France": "FR",
    "Germany": "DE",
    "Greece": "GR",
    "Hungary": "HU",
    "Ireland": "IE",
    "Italy": "IT",
    "Latvia": "LV",
    "Lithuania": "LT",
    "Luxembourg": "LU",
    "Malta": "MT",
    "Netherlands": "NL",
    "Poland": "PL",
    "Portugal": "PT",
    "Romania": "RO",
    "Slovakia": "SK",
    "Slovenia": "SI",
    "Spain": "ES",
    "Sweden": "SE",
    "United Kingdom": "GB",
}

export const PRODUCT_STYLES = [
    'Classic',
    'Modern',
    'Vintage',
    'Elegant',
    'Minimalistic',
    'Scandinavian',
    'Industrial',
    'Boho',
    'Art Deco',
]

export const PRODUCT_SIZES = ['XS', 'S', 'M', 'L', 'XL']

export const getCountryNameByCode = (code) => {
    for (const country in AVAILABLE_COUNTRIES) {
        if (AVAILABLE_COUNTRIES[country] === code) {
            return country;
        }
    }
    return null;
}
